import React, { useEffect, useState } from "react";
import { PasswordChange } from "../../../hooks/Service";
import { toast } from 'react-toastify';

const ChangePassword = (props) => {
   const [fillpass, setfillpass] = useState();
   const [Success, setSuccess] = useState(false);
   const [loading, setloading] = useState(false);
   const [checkPassword, setCheckPassword] = useState(true)
   const [pass,setPass]= useState({
    oldPwd:"",
    newPwd:"",
    pwdHint:""
   })
  // useEffect(()=>{
  //   let Data = JSON.parse(localStorage.getItem("ProfileTab"))
  //   let old_password = Data?.Password;
  // },[])
   onchange=(e)=>{
    let Obj ={...pass};
    Obj[e.target.name]= e.target.value;
    setPass({...Obj})
   }
const CheckPassword = () => {
  if((pass)){
   setfillpass(validate(pass));
  }else{
    setfillpass('');
  }
  
}
const validate = (values) => {
    // let Data = JSON.parse(localStorage.getItem("ProfileTab"))
    // let old_password = Data?.Password;
  let errors 

  if (!values.oldPwd || !values.newPwd) {
    errors = "Cannot be blank";
    toast.error("pls fill the input")
    return errors;
  } 
   if (values.oldPwd.length < 6 || values.newPwd.length<6) {
    return  "Password must be more than 8 characters";
    // return;

  }
  // else if(pass?.oldPwd !== old_password){
  //   errors = "Please Enter Valid Old Password!!!"
  // }else if(old_password == values.newPwd){
  //   errors = "Old password and new password not be same!!!"
  // }
  // else{
    ValidatePassword()
  // }
    // return errors;
};
const ValidatePassword = async() => {
  setloading(true);
  let data = await PasswordChange(pass)
  if(data.status && data.result.Data.Response ==="N"){
    setfillpass(data.result.Message)
  }else if(data.status && data.result.Data.Response ==="Y"){
    setSuccess("Password Changed Sucessfully")
    toast.success("Sucessfully Password")
    setPass({oldPwd:"",newPwd:"", pwdHint:""})
  }
  setloading(false)

}
  return (
    <>
      <div
        id="Change Password"
        className="border back-forword-btn lg:w-[40%] md:w-[70%] w-[84%] mx-auto rounded-2xl px-10 py-10 mb-6 "
      >
        <div className="flex justify-start cursor-pointer	"onClick={()=>{
        if(props.flag){
          props.setcurrentTab(props.flag)
        }else{
        props.setcurrentTab("change");}
      }}>
        <div className="text-base flex text-[#2563eb]"><svg width="24" height="24" viewBox="0 0 24 24" fill="#2563eb" xmlns="http://www.w3.org/2000/svg">
<path d="M9.57 5.92969L3.5 11.9997L9.57 18.0697" stroke="#2563eb" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M20.4999 12H3.66992" stroke="#2563eb" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
Back</div>
      </div>
        <div className="font-medium lg:text-lg md:text-lg text-[14px] text-left  py-4 text-[#0A2A4A]">
          Change Password
        </div>
        <div className="relative z-0 w-full mb-6 group">
          <input
            type="password"
            name="oldPwd"
            className="block py-2.5 px-0 w-full lg:text-lg md:text-lg text-[14px] text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-blue-600 peer"
            placeholder=" "
            value={pass.oldPwd}
            required=""
            onChange={onchange}
          />
          <label
            htmlFor="first"
            className="peer-focus:font-medium absolute lg:text-md md:text-md text-[13px] font-medium text-[#0A2A4A] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
          >
            Password
          </label>
        </div>
        <div className="relative z-0 w-full mb-6 group">
          <input
            type="password"
            name="newPwd"
            value={pass.newPwd}
            className="block py-2.5 px-0 w-full lg:text-md md:text-md text-[14px] text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-blue-600 peer"
            placeholder=" "
            required=""
            onChange={onchange}

          />
          <label
            htmlFor="second"
            className="peer-focus:font-medium absolute lg:text-md md:text-md text-[13px] font-medium text-[#0A2A4A] duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
          >
            New Password
          </label>
        </div>
        <div className="relative z-0 w-full mb-6 group">
          <input
            type="password"
            name="pwdHint"
            value={pass.pwdHint}
            className="block py-2.5 px-0 w-full lg:text-md md:text-md text-[14px] text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-black dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
            placeholder=" "
            required=""
            onChange={onchange}

          />
          <label
            htmlFor="floating_email"
            className="peer-focus:font-medium absolute lg:text-md md:text-md text-[13px] font-medium text-[#0A2A4A] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
          >
            Password Hint
          </label>
        </div>
        {fillpass && <div className="text-red-500 mx-2" >{fillpass}</div>}
        {Success && <div className="text-green-500 mx-2" >{Success}</div>}
        <div className=" text-center  my-4">
          <button
            onClick={CheckPassword}
            type="submit"
            className="text-white text-lg  bg-[#3491FF] hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg  lg:w-full md:w-full w-auto sm:w-auto px-6 py-2 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
          >  {loading ?    <div role="status" >
          <svg aria-hidden="true" className="ml-[4px] w-6 h-6 items-center justify-center text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
              <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
          </svg>
          <span className="sr-only">Loading...</span>
      </div> : <>Change</>}
            
          </button>
        
        </div>
      </div> 
      <div className="flex justify-end mb-6 mr-12" onClick={()=>{
        if(props.flag){
          props.setcurrentTab(props.flag)
        }else{
        props.setcurrentTab("change");}
      }}>
       
      </div>
    </>
  );
};

export default ChangePassword;
